import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Checkbox from '../Checkbox/Checkbox';
import Radio from '../Radio/Radio';
import { selectClass } from './styles';
import { getDirectionClass } from '../utils/classname';

var BoxOption =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BoxOption, _PureComponent);

  var _super = _createSuper2(BoxOption);

  function BoxOption(props) {
    var _this;

    _classCallCheck(this, BoxOption);

    _this = _super.call(this, props);
    _this.locked = void 0;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BoxOption, [{
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          onClick = _this$props.onClick,
          isActive = _this$props.isActive,
          disabled = _this$props.disabled;
      if (this.locked || disabled) return;
      this.locked = true;
      onClick(!isActive, data);
      setTimeout(function () {
        _this2.locked = false;
      }, 200);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          isActive = _this$props2.isActive,
          renderItem = _this$props2.renderItem,
          columns = _this$props2.columns,
          multiple = _this$props2.multiple,
          disabled = _this$props2.disabled;
      var className = selectClass(getDirectionClass('option'));
      var width = columns < 0 ? undefined : "".concat(1 / columns * 100, "%");
      var Input = multiple ? Checkbox : Radio;
      var result = renderItem(data);
      var title = typeof result === 'string' ? result : undefined;
      return (
        /*#__PURE__*/
        React.createElement(Input, {
          disabled: disabled,
          style: {
            width: width
          },
          checked: isActive,
          className: className,
          onChange: this.handleClick
        },
        /*#__PURE__*/
        React.createElement("span", {
          title: title
        }, result))
      );
    }
  }]);

  return BoxOption;
}(PureComponent);

export default BoxOption;